import classNames from "classnames";
import { NavLink } from "react-router";
import "./index.scss";

const Logo = ({ className = null, variant = "" }) => (
  <div className={classNames("pdl_component_logo", className)}>
    <NavLink to="/home">
      <img
        src={`/images/logo_${variant}.png`}
        alt="Plataforma LEX"
        className={`pdl_component_logo_img ${
          variant && `pdl_component_logo_img_${variant}`
        }`}
      />
    </NavLink>
  </div>
);

export default Logo;
